import { render, staticRenderFns } from "./SerialNumberQRCode.vue?vue&type=template&id=44ca5597&scoped=true"
import script from "./SerialNumberQRCode.vue?vue&type=script&lang=js"
export * from "./SerialNumberQRCode.vue?vue&type=script&lang=js"
import style0 from "./SerialNumberQRCode.vue?vue&type=style&index=0&id=44ca5597&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca5597",
  null
  
)

export default component.exports